/**
 * Consumes a `?venue=<id>` / `?venue=all` override (#689): stores it for the current env (localStorage) and drops
 * the param from the URL. Ignored (param left alone) when the build locks the venue. main.tsx also applies the
 * param once before the first render so a shared link never flashes the unscoped catalog.
 */
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useEnv } from '../config/env';
import { VENUE_PARAM } from './scope';
import { venueStore } from './useVenueScope';

export default function VenueUrlSync() {
  const { env } = useEnv();
  const [params, setParams] = useSearchParams();
  const raw = params.get(VENUE_PARAM);
  useEffect(() => {
    if (raw === null) return;
    if (!venueStore.applyUrl(env.name, raw)) return;
    setParams(
      (prev) => {
        const next = new URLSearchParams(prev);
        next.delete(VENUE_PARAM);
        return next;
      },
      { replace: true },
    );
  }, [raw, env.name, setParams]);
  return null;
}
